"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerConfigUpdateDto = void 0;
const misc_1 = require("../../../misc");
const server_config_1 = require("../server.config");
class ServerConfigUpdateDto extends (0, misc_1.generateCreateDto)(server_config_1.ServerConfig, [
    'android',
    'conferencePingTimeout',
    'tac',
    'iceServers',
    'iceTransportPolicy',
    'ios',
    'retryThreshold',
    'trickleIce',
    'supportPhoneNumber',
    'notificationsOnNewVisit',
    'maxVideoSizeMb',
]) {
}
exports.ServerConfigUpdateDto = ServerConfigUpdateDto;
